// import { useState } from 'react';

import FrameSection from '../../../components/dnd/FrameSection';

type MagicItemData = {
    id: string;
    name: string;
};

type MagicItemsProps = {
    items: MagicItemData[];
};

function MagicItems({
    items
}: MagicItemsProps) {
    // const [magicItems, setMagicItems] = useState<MagicItemData[]>(items);

    return (
        <>
            <FrameSection title="Magic Items" />
        </>
    );
}

export default MagicItems;